module.exports = __webpack_public_path__ + "img/email.889907b0.svg";